import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ggPayment from 'ggApp/modules/payment';

import { CreatePaymentScreen, ListPaymentScreen } from 'ggApp/shared/screens/Checkout/Payment';

const mapStateToProps = createStructuredSelector({
    paymentMethodListByUser: ggPayment.selectors.listUserPaymentMethods,
});
const CheckoutPayment = ({ paymentMethodListByUser }) => {
    const noPaymentMethods = paymentMethodListByUser.length === 0;
    const screen = noPaymentMethods ? CreatePaymentScreen : ListPaymentScreen;
    return React.createElement(screen);
};

export default connect(mapStateToProps)(CheckoutPayment);
